module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationMOdal()
      }
    }
  }, [_vm._v("Show Quotation")]), _vm._v(" "), (_vm.QT_fk_all_module_id) ? _c('b-modal', {
    ref: "QuptationSummary-modal",
    attrs: {
      "id": "QuptationSummary-modalId",
      "title": 'Quotation Summary - ' + _vm.QT_jb_series,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [(
    _vm.mainExecutionDetails.length > 0 &&
    _vm.mainExecutionDetails[0].finalBillingCompleted == '0'
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showQuotation
    }
  }, [_vm._v("Show Quotation")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.tptTableData.length > 0 && _vm.setShowQuotation == true) ? _c('div', {
    staticClass: "box-body gutr"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.tempffTableArry.length > 0) ? _c('b-button', {
    attrs: {
      "variant": _vm.tptTableArryType == 'FF' ? 'success' : 'outline-success'
    },
    on: {
      "click": function($event) {
        _vm.setQuotationType('FF')
      }
    }
  }, [_vm._v("\n              FF\n            ")]) : _vm._e(), _vm._v(" "), (_vm.ccTableArry.length > 0) ? _c('b-button', {
    attrs: {
      "variant": _vm.tptTableArryType == 'CC' ? 'success' : 'outline-success'
    },
    on: {
      "click": function($event) {
        _vm.setQuotationType('CC')
      }
    }
  }, [_vm._v("\n              CC\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tptTableData.length > 0) ? _c('b-button', {
    attrs: {
      "variant": _vm.tptTableArryType == 'TPT' ? 'success' : 'outline-success'
    },
    on: {
      "click": function($event) {
        _vm.setQuotationType('TPT')
      }
    }
  }, [_vm._v("\n              TPT\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.tptTableData.length > 0 && _vm.setShowQuotation == true) ? _c('div', {
    staticClass: "box-body gutr"
  }, [(_vm.tptTableArryType == 'TPT') ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buy In Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Validity Date")]), _vm._v(" "), _c('th', [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tptTableData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.containerType) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.otherCharge))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.byInPrice) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.unitName ? item1.unitName : "NA") + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.validityDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.remark))])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ccTableArry.length > 0 && _vm.setShowQuotation == true) ? _c('div', {
    staticClass: "box-body gutr"
  }, [(_vm.tptTableArryType == 'CC') ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "cc"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), (_vm.enquiryData.shipmentType == '1') ? _c('th', [_vm._v("Container Type")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buy In Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Validity Date")]), _vm._v(" "), _c('th', [_vm._v("Unit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ccTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.enquiryData.shipmentType == '1') ? _c('td', [_vm._v("\n                  " + _vm._s(item1.containerType) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ccType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ccBuyingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ccSellingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.validityDate))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.unitName ? item1.unitName : "NA") + "\n                ")])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tempffTableArry.length > 0 && _vm.setShowQuotation == true) ? _c('div', {
    staticClass: "box-body gutr"
  }, [(_vm.tptTableArryType == 'FF') ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), (
    _vm.enquiryData.shipmentType == 1 &&
    _vm.enquiryData.fclOrlcl == 'lcl'
  ) ? _c('th', [_vm._v("\n                  Co-Loader\n                ")]) : (_vm.enquiryData.shipmentType == 1) ? _c('th', [_vm._v("\n                  Shipping Line\n                ")]) : _c('th', [_vm._v("Airline Name")]), _vm._v(" "), (_vm.shipmentType == '1') ? _c('th', [_vm._v("Container Type")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buying Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Quotation Validity Till")]), _vm._v(" "), _c('th', [_vm._v("Validity Date")]), _vm._v(" "), _c('th', [_vm._v("Unit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tempffTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (
      _vm.enquiryData.shipmentType == '1' &&
      _vm.enquiryData.fclOrlcl == 'lcl'
    ) ? _c('td', [_vm._v("\n                  " + _vm._s(item1.coLoaderName) + "\n                ")]) : (_vm.enquiryData.shipmentType == '1') ? _c('td', [_vm._v("\n                  " + _vm._s(item1.shippingLine) + "\n                ")]) : _c('td', [_vm._v(_vm._s(item1.airlineName))]), _vm._v(" "), (_vm.enquiryData.shipmentType == '1') ? _c('td', [_vm._v("\n                  " + _vm._s(item1.containerType) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.buyingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffSellingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.quotationTill == 1 ?
      "Validity Till Handover" :
      "Validity Till Sailing") + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.ffvalidityDate) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.unitName ? item1.unitName : "NA") + "\n                ")])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.billingTableData.length > 0) ? _c('div', {
    staticClass: "box"
  }, [(_vm.showMoreNewItem == true) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Tally Invoice No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Tally Status")]), _vm._v(" "), _c('th', [_vm._v("Added In Tally")]), _vm._v(" "), _c('th', [_vm._v("Date & Details")]), _vm._v(" "), _c('th', [_vm._v("PDF")])]), _vm._v(" "), _vm._l((_vm.billingTableData), function(item1, index) {
    return _c('tr', {
      key: index,
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red')
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red'),
      on: {
        "click": function($event) {
          _vm.getBillData(item1)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item1.BillingSeries) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.clientName) + "\n                    "), _c('br'), _vm._v(" "), (item1.invoiceForClient == '2') ? _c('b-badge', [_vm._v("Overseas Agent")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.jobType))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.TallyResponse == "" ?
      "Failed To connect to Tally" :
      item1.LINEERROR == "" && item1.CREATED != "0" ?
      "DATA ADDED SUCCESSFULLY IN TALLY " :
      item1.LINEERROR) + "\n                  ")]), _vm._v(" "), _c('td', [_c('md-icon', {
      staticClass: "md-size md-accent",
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red')
    }, [_vm._v(_vm._s(item1.TallyResponse == "" ?
      "clear" :
      item1.LINEERROR == "" && item1.CREATED != "0" ?
      "done_outline" :
      "clear"))])], 1), _vm._v(" "), _c('td', [_vm._v("\n                    On " + _vm._s(item1.loginTime) + "\n                    "), _c('br'), _vm._v("\n                    By " + _vm._s(item1.employeeName) + "\n                    "), _c('br'), _vm._v("\n                    At " + _vm._s(item1.billingLocationName) + "\n                  ")]), _vm._v(" "), _c('td', [(item1.dataPdf) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/TALLY_PDF/" + item1.dataPdf,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View PDF")]) : _vm._e()])])
  })], 2)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationMOdal()
      }
    }
  }, [_vm._v("\n      Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed757818","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/quotationSummary.vue
// module id = 2906
// module chunks = 0